import type { TemplateOnlyComponent } from '@ember/component/template-only';
import Section from 'bcl/components/section';

export default <template>
  <header class="bg-white shadow-sm print:hidden" ...attributes>
    <div class="mx-auto max-w-7xl py-4 px-4 lg:px-8">
      <h1
        class="text-lg inline font-semibold leading-6 text-gray-900"
      >{{@title}}</h1>
      {{yield to="header"}}
    </div>
  </header>
  <main>
    {{#if @noWrapper}}
      {{yield}}
    {{else}}
      <div class="mt-4 print:mt-0 mx-auto max-w-7xl print:max-w-none">
        <Section>
          {{yield}}
        </Section>
      </div>
    {{/if}}
  </main>
</template> satisfies TemplateOnlyComponent<{
  Args: { title: string; noWrapper?: boolean };
  Element: HTMLHeadingElement;
  Blocks: {
    default: [];
    header: [];
  };
}>;
